import axios from 'axios';
import Cookies from 'universal-cookie';
import { BASE_API_URL } from './endpoint';

const cookies = new Cookies();

const RestClient = axios.create({
  baseURL: BASE_API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  responseType: 'json',
  withCredentials: true
});

RestClient.interceptors.request.use(
  (config) => {
    const token = cookies.get('auth_token'); // Assuming the token is stored under "auth_token"
    if (token) {
      // config.headers['Authorization'] = `Token ${token}`; // Use "Token" followed by the actual token
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('⚠ No Auth Token found in cookies!');
    }

    const csrfToken = cookies.get('csrftoken');
    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken; // Include CSRF token if necessary
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// export default RestClient;

/* To use this interceptor for post and get examples in the middleware:
const data = {
    key1: "value1",
    key2: "value2"
};
1. Fetch/post data with default json type RestClient.get("/api/v1/endpoint/", data)
2. Fetch/post data with overriden responseType RestClient.get("/api/v1/endpoint/", data, { responseType: "blob" })
3. Fetch/post data with overriden headers RestClient.get("/api/v1/endpoint/", data, { headers: { "Content-Type": "application/json" } })
*/

export default RestClient;
